import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { RoleSysBilling } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { NotFoundPage } from '../../../../page/not-found'
import { CatalogPage } from './catalog-page'
import { EntitlementsPage } from './entitlements-page'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// The trail: Billing > Plan catalog | Organization entitlements (audit F7).
export const CATALOG_CRUMB = { url: '/admin/billing/catalog', text: 'Plan catalog' }
export const ENTITLEMENTS_CRUMB = { url: '/admin/billing/organizations', text: 'Organization entitlements' }

// /admin/billing: the plan catalog and one organization's entitlements, for
// staff, read-only (recompute aside). The route itself is gated by
// SYS_BILLING read, so a typed address without it says so; an address under
// it that is no page is the app's not-found page.
export const LayoutBilling = () =>
  <Route path="/admin/billing">
    <RoleSysBilling accessRead fallback={<NoAccess what="Billing" />}>
      <Switch>
        <Route exact path="/admin/billing"><Redirect to="/admin/billing/catalog" /></Route>
        <Route exact path="/admin/billing/catalog"><PageTrail trail={[SECTION.billing, CATALOG_CRUMB]} /><CatalogPage /></Route>
        <Route exact path="/admin/billing/organizations"><PageTrail trail={[SECTION.billing, ENTITLEMENTS_CRUMB]} /><EntitlementsPage /></Route>
        <Route exact path="/admin/billing/organizations/:organizationID(\d+)"><PageTrail trail={[SECTION.billing, ENTITLEMENTS_CRUMB]} /><EntitlementsPage /></Route>
        <Route render={({ location }) => <NotFoundPage pathname={location.pathname} />} />
      </Switch>
    </RoleSysBilling>
  </Route>
